import React, { useContext, useState, useEffect } from 'react';

import ModalContext from '../../../context/ModalContext.js';
import { Add, CloseRounded } from '@mui/icons-material';
import { CircularProgress, TextField, Checkbox, FormControlLabel } from '@mui/material';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { toast } from 'react-toastify';
import AuthContext from '../../../context/AuthContext.js';
import { useCouponContext } from '../../../context/CouponContext.js';
import CustomButton from '../../../common/CustomButton.jsx';
import ManualLocationSync from '../../../common/ManualLocationSync.jsx';
import {
    setDefaults,
    fromLatLng,
  } from "react-geocode";

  setDefaults({
    key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY, // Your API key here.
    language: "en", // Default language for responses.
    region: "es", // Default region for responses.
  });


const AddLocationModal = ({ modalDetails }) => {

    const [loading, setLoading] = useState(true);
    const [addingLocation, setAddingLocations] = useState(false);
    const [updateCountryLoading, setUpdateCountryLoading] = useState(false);
    const [needsManualCountry, setNeedsManualCountry] = useState(false);
    const [locationId, setLocationId] = useState(null);
    const [countries, setCountries] = useState([]);

    const [selectedLocation, setSelectedLocation] = useState({});
    
    const {company, addHandler} = modalDetails;


    console.log(modalDetails);
    const modalCtx = useContext(ModalContext);
    const authCtx = useContext(AuthContext);

    const { couponState, updateCouponState } = useCouponContext();

    const closeHandle = () => {
        modalCtx.closeModal();
    }

    const [agent, setAgent] = React.useState('');

    const handleChange = (event) => {
        setAgent(event.target.value);
    };

    // Form Details

    const [locationDetails, setLocationDetails]= useState({
        title:"",
        address:"",
        phoneNumber:"",
        email:"",
        country:"",
        countryCode:"",
    })

    // Manual sync location details
    const [manualLocationDetails, setManualLocationDetails] = useState({
        country: "",
        state: "",
        city: ""
    })

    // Determine default regional checkbox state based on coupon availability mode
    const getDefaultIsRegional = () => {
        const couponType = modalDetails?.locationDetails?.couponAvailability || (modalDetails?.locationDetails?.onlineOnly === "yes" ? "online" : "instore");
        // For instore: false (not selected), for online and both: true (selected)
        return couponType === "online" || couponType === "both";
    }

    const [isRegional, setIsRegional] = useState(getDefaultIsRegional());

    //Map Related Details

    const [latLng, setLatLng] = useState({
        lat: 0, lng: 0
    })

    const getCurrentLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    console.log(position.coords);
                    setLatLng({
                        lat: latitude,
                        lng: longitude
                    })
                    setLoading(false);
                   
                },
                (error) => {
                    console.error("Error getting current location:", error);
                }
            );
        } else {
            setLoading(false);
            console.error("Geolocation is not supported by this browser.");
        }
    };

    // Call the function to get the current location

    useEffect(() => {
        getCurrentLocation();
    }, [])

  // Fetch countries list
  const getAllCountries = () => {
    fetch(`${process.env.REACT_APP_API_URI}/v3/admin/companies/countries`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + authCtx.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          setCountries([...data?.data]);
        }
      })
      .catch((err) => {
        console.error("Error fetching countries:", err);
      });
  };

  useEffect(() => {
    getAllCountries();
  }, [])

    // Update regional checkbox when modal opens with different coupon modes
    useEffect(() => {
        setIsRegional(getDefaultIsRegional());
    }, [modalDetails?.locationDetails?.couponAvailability, modalDetails?.locationDetails?.onlineOnly])

     
    useEffect(()=>{
        console.log("calling details")
        
      
    }, [latLng])

    const handleMapClick = (e) => {

        console.log(e);
        setSelectedLocation({
            lat: e.detail.latLng?.lat,
            lng: e.detail.latLng?.lng
        });

        fromLatLng(e.detail.latLng?.lat, e.detail.latLng?.lng)
            .then(({ results }) => {
                const { lat, lng } = results[0].geometry.location;
                console.log(results, "this is result");

                setLocationDetails({
                    ...locationDetails,
                    address: results[0].formatted_address,
                    country: results[0].address_components.find(item => item.types.includes("country")).long_name,
                    countryCode: results[0].address_components.find(item => item.types.includes("country")).short_name,                
                })

                console.log("curent location detais", locationDetails);
            })
            .catch(console.error);
    };


    const addLocation = ()=>{
        if(locationDetails.address == "" || locationDetails.title == ""){
            toast("Please fill all the required details first");
        }else {
            setAddingLocations(true);
            
            var locationPayload = {
                companyId: company.id,
                latitude:selectedLocation.lat,
                longitude:selectedLocation.lng,
                country: locationDetails.country,
                address:locationDetails.address, 
                email:locationDetails.email, 
                phone: locationDetails.phoneNumber, 
                title: locationDetails.title,
                isRegional: isRegional
              };

            try{
                fetch(process.env.REACT_APP_API_URI + `/v3/admin/company/${locationPayload.companyId}/location`, {
                    method:"POST",
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${authCtx.token}` },
                    body:JSON.stringify(locationPayload)
                }).then((res)=> {return res.json()}).then((data) => {

                    if(data.status == 'success'){
                        // Check if manual sync is required
                        if(data.needsManualCountry === true){
                            setNeedsManualCountry(true);
                            setLocationId(data.id);
                            setAddingLocations(false);
                        } else {
                            var newLocationDetail= {
                                "id":data.id,
                                "title": locationPayload.title,
                                "address": locationPayload.address,
                                "country": locationPayload.country,
                                "latitude": locationPayload.latitude,
                                "longitude": locationPayload.longitude,
                                "locationType": isRegional ? "regional" : "local"
                            };
                            // addLocationinLocalStorage(newLocationDetail);
                            addHandler(newLocationDetail);
                            setAddingLocations(false);
                            modalCtx.closeModal();
                        }
                    } else {
                        setAddingLocations(false);
                        toast.error(data.message || "Failed to add location");
                    }
                })
            }catch(e){
                setAddingLocations(false);
                toast.error("Error adding location");
                console.error(e);
            }
        }
    }

  const handleUpdateCountry = async () => {
    try {
      setUpdateCountryLoading(true);
      const response = await fetch(`${process.env.REACT_APP_API_URI}/v3/admin/location/${locationId}/country`, {
        method: 'PUT',
        headers: { 
          'Content-Type': 'application/json', 
          Authorization: `Bearer ${authCtx.token}` 
        },
        body: JSON.stringify({
          country: manualLocationDetails.country,
          state: manualLocationDetails.state,
          city: manualLocationDetails.city
        })
      });

      const data = await response.json();
      
      if (data.status === "success") {
        toast.success("Location updated successfully");
        var newLocationDetail= {
          "id": locationId,
          "title": locationDetails.title,
          "address": locationDetails.address,
          "country": manualLocationDetails.country,
          "latitude": selectedLocation.lat,
          "longitude": selectedLocation.lng,
          "locationType": isRegional ? "regional" : "local"
        };
        addHandler(newLocationDetail);
        setNeedsManualCountry(false);
        setUpdateCountryLoading(false);
        modalCtx.closeModal();
      } else {
        toast.error(data.message || "Failed to update location");
        setUpdateCountryLoading(false);
      }
    } catch (error) {
      console.error('Error updating country:', error);
      setUpdateCountryLoading(false);
      toast.error("Error updating location");
    }
  };

    return (
        <>
            <div className="create-devotional-container add-location-modal">

                <CloseRounded className='close' onClick={() => closeHandle()} />

                <div className="map-body-container">

                    <div className='map'>


                        {loading ? <div>
                            <CircularProgress />
                        </div> : <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
                            <Map
                                defaultCenter={

                                    {
                                        lat: latLng.lat,
                                        lng: latLng.lng
                                    }

                                }
                                defaultZoom={11}
                                gestureHandling={'greedy'}
                                onClick={handleMapClick}

                            // disableDefaultUI={true}
                            >
                                {
                                    selectedLocation.lat && <>
                                        <Marker position={selectedLocation} /></>
                                }

                            </Map>


                        </APIProvider>}
                    </div>
                    {!needsManualCountry ? (
                        <div className='textfield-container'>
                            <TextField 
                                value={locationDetails.address}
                                onChange={(e)=>{
                                    setLocationDetails({...locationDetails, address: e.target.value})
                                }}
                                fullWidth
                                required
                                id="standard-required"
                                label="Address"
                                // defaultValue="Hello World"
                                placeholder='Enter your address'
                                variant="standard"
                            />
                            <TextField
                            value={locationDetails.title}
                            onChange={(e)=>{ setLocationDetails({...locationDetails, title : e.target.value}) }}
                                fullWidth
                                required
                                id="standard-required"
                                label="Title"
                                placeholder='Assign a title for your address'
                                // defaultValue="Hello World"
                                variant="standard"
                            />
                            <TextField
                            value={locationDetails.phoneNumber}
                            onChange={(e)=>{ setLocationDetails({...locationDetails, phoneNumber : e.target.value}) }}
                                fullWidth
                                id="standard-required"
                                label="Phone"
                                placeholder='Phone'
                                // defaultValue="Hello World"
                                variant="standard"
                            />
                            <TextField
                            value={locationDetails.email}
                            onChange={(e)=>{ setLocationDetails({...locationDetails, email : e.target.value}) }}
                                fullWidth
                                id="standard-required"
                                label="Email"
                                placeholder='Email'
                                // defaultValue="Hello World"
                                variant="standard"
                            />
                            
                            <FormControlLabel
                                control={
                                    <Checkbox checked={isRegional} onChange={(e) => setIsRegional(e.target.checked)} color="primary" />
                                }
                                label="Regional Location"
                                style={{ marginTop: '10px', whiteSpace: 'nowrap' }}
                                sx={{ '& .MuiFormControlLabel-label': { whiteSpace: 'nowrap' } }}
                            />

                          <CustomButton disabled={addingLocation} className='roundedFull' onClick={()=> addLocation()} ><Add   /></CustomButton>  
                        </div>
                    ) : (
                        <ManualLocationSync
                            countries={countries}
                            locationDetails={manualLocationDetails}
                            onLocationChange={setManualLocationDetails}
                            onUpdate={handleUpdateCountry}
                            loading={updateCountryLoading}
                        />
                    )}
                </div>

            </div>
        </>
    )
}

export default AddLocationModal;
